import React from 'react';
import G from "../../libs/Glob.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import {Form, Input, InputGroup, InputGroupText, Label} from "reactstrap";
import appLib from "../../libs/appLib.mjs";
import MultiLangLabelField from "../fields/MultiLangLabelField.mjs";
import IntervalTypeField from "../fields/IntervalTypeField.mjs";
import TagsEditor from "../fields/TagsEditor.mjs";
import TagsIcon from "../../media/images/TagsIcon.mjs";

const prefix = 'FormLibraryRootNodeEditor';

const FormLibraryRootNodeEditor = class extends React.Component {
	constructor(props) {
		super(props);
		const d = props?.data ?? {};
		/** @type {AthenaLibraryDefinitionRootNode} */
		const data = {
			uuid : d?.uuid ?? G.generateUid('lib'),
			languages: d?.languages ?? [ appLib.defaultLanguage() ],
			defaultLanguage: d?.defaultLanguage ?? appLib.defaultLanguage(),
			version: d?.version ?? 1,
			coverageMax: d?.coverage ?? 5,
			maturityMax: d?.maturityMax ?? 5,
			coverageAggr: d?.coverageAggr ?? 'avg',
			maturityAggr: d?.maturityAggr ?? 'avg',
			mandatory: d?.mandatory ?? 'N',
		};
		Object.assign( data, d );
		this.state = { data: data };
		this.uid = G.generateUid(prefix);
		this.setData = this.setData.bind(this);
		this.setValid = this.setValid.bind(this);
		this.setValue = this.setValue.bind(this);
		this.setLang = this.setLang.bind(this);
	}
	componentDidMount() {
		appLib.listLibraries().then( (libraries) => {
			this.setState({libraries: libraries});
		});
		this.setValid();
	}
	setData(d) {
		this.setState( { data: d }, ()=>{
			if ( typeof this.props.setData === 'function') this.props.setData(d);
			this.setValid();
		} );
	}
	setValid() {
		if ( typeof this.props.setValid === 'function') {
			setTimeout( ()=>{
				this.props.setValid(! window.document.querySelector(`#${this.uid} .is-invalid`));
			}, 500);
		}
	}
	/**
	 * @param {Event|HTMLFormElement|string} field
	 * @param {string|number|boolean|null} [value]
	 * @return {void}
	 */
	setValue = (field, value ) => {
		if ( field?.target ) field = field.target;
		if ( field?.name ) {
			value = field.value;
			field = field.name;
		}
		const data = this.state.data;
		if ( ! value ) {
			delete data[field];
		} else {
			data[field] = value;
		}
		this.setData( data );
	}
	setLang( l ) {
		const data = this.state.data;
		if ( data.languages.includes(l) ) {
			data.languages = data.languages.filter( k => k !== l );
		} else {
			data.languages.push(l);
		}
		if ( data.languages.length === 0 ) data.languages = [appLib.defaultLanguage()];
		if ( ! data.languages.includes( data.defaultLanguage )) {
			data.defaultLanguage = data.languages[0];
		}
		this.setData( data );
	}
	render() {
		if ( ! this.state.libraries ) return '';
		return(
			<Form
				id={this.uid}
				className={'library-editor '+prefix}
				autoComplete="off"
				onSubmit={ (evt) => {
					evt.preventDefault();
				}}
			>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"UUID"} />
						</Label>
					</InputGroupText>
					<Input
						name={"uuid"}
						value={ this.state.data.uuid || '' }
						readOnly={true}
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Code"} />
						</Label>
					</InputGroupText>
					<Input
						name={"code"}
						value={ this.state.data.code || '' }
						onChange={ e => {
							this.setValue('code', e.target.value.replace(/[^a-z0-9./-]+/gi,'_'));
						} }
						valid={ !! this.state.data.code }
						invalid={ ! this.state.data.code  }
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Visible code"} />
						</Label>
					</InputGroupText>
					<Input
						name={"viewcode"}
						value={ this.state.data.viewcode || '' }
						placeholder={ G.label('ViewcodePlaceholder') }
						onChange={ e => {
							this.setValue('viewcode', e.target.value.replace(/[^a-z0-9./-]+/gi,'_'));
						} }
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Name"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<MultiLangLabelField
							value={ this.state.data.name }
							langs={ this.state.data.languages }
							onChange={ n => { this.setValue( 'name', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Description"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<MultiLangLabelField
							value={ this.state.data.description }
							langs={ this.state.data.languages }
							long={true}
							onChange={ n => { this.setValue( 'description', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Version"} />
						</Label>
					</InputGroupText>
					<Input
						type={"number"}
						name={"version"}
						value={ (Math.round( (this.state.data.version||1) * 100) /100).toFixed( 2) }
						onChange={ e => {
							const v = parseFloat(e.target.value || '1');
							this.setValue('version', (Math.round( v * 100) /100) );
						} }
						valid={ !! this.state.data.version }
						invalid={ ! this.state.data.version  }
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Published"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"clear"}>
						<IntervalTypeField
							values={ [{value: false, label: G.label('No') },{value: true, label: G.label('Yes') }] }
							value={ !! this.state.data?.published }
							onChange={ n => { this.setValue( 'published', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Mandatory"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"clear"}>
						<IntervalTypeField
							values={ appLib.mandatoryValues() }
							value={ this.state.data.mandatory }
							root={true}
							onChange={ n => { this.setValue( 'mandatory', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Languages"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						{ appLib.languages().map((l,i)=> (
							<span
								key={i}
								onClick={() => {
									this.setLang(l.id)
								}}
								className={"langCheck "+(this.state.data.languages.includes(l.id) ? 'checked' : 'unchecked')}
							>
								<img alt={l.label} title={l.label} height={24} src={l.flag}/>
							</span>
						))}
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Default language"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						{ appLib.languages().filter( l => this.state.data.languages.includes(l.id)).map((l,i)=> (
							<span
								key={i}
								onClick={() => {
									this.setValue('defaultLanguage', l.id)
								}}
								className={"langCheck "+(this.state.data.defaultLanguage === l.id ? 'checked' : 'unchecked')}
							>
								<img alt={l.label} title={l.label} height={24} src={l.flag}/>
						</span>
						))}
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TagsIcon />
						</Label>
					</InputGroupText>
					<TagsEditor
						value={ this.state.data.tags || [] }
						onChange={ n => { this.setValue( 'tags', n ) }}
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Coverage"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							value={this.state.data.coverageMax}
							root={true}
							onChange={ n => { this.setValue( 'coverageMax', n ) }}
						/>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							values={ appLib.aggregationValues() }
							value={this.state.data.coverageAggr}
							root={true}
							onChange={ n => { this.setValue( 'coverageAggr', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Maturity"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							value={this.state.data.maturityMax}
							root={true}
							onChange={ n => { this.setValue( 'maturityMax', n ) }}
						/>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							values={ appLib.aggregationValues() }
							value={this.state.data.maturityAggr}
							root={true}
							onChange={ n => { this.setValue( 'maturityAggr', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Private notes"} />
						</Label>
					</InputGroupText>
					<Input
						name={"note"}
						value={ this.state.data.pnote || '' }
						onChange={ this.setValue }
						type={'textarea'}
					/>
				</InputGroup>
			</Form>
		);
	}
}

export default FormLibraryRootNodeEditor;